import React, { useState } from 'react';
import logo from '../LinchpinCRTLOGOfinal.png';

export default function ResetPassword() {
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [codeSent, setCodeSent] = useState(false);

  const requirements = [
    { label: '8+ characters', met: password.length >= 8 },
    { label: 'Uppercase letter (A-Z)', met: /[A-Z]/.test(password) },
    { label: 'Lowercase letter (a-z)', met: /[a-z]/.test(password) },
    { label: 'Number (0-9)', met: /[0-9]/.test(password) },
    { label: 'Special character (!@#$%)', met: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password) },
  ];
  const allMet = requirements.every(r => r.met);

  async function handleReset(e) {
    e.preventDefault();
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    if (!allMet) { setError('Please meet all password requirements.'); return; }
    setLoading(true); setError('');

    const result = await fetch('/auth/reset-password', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, code, newPassword: password })
    }).then(r => r.json());

    setLoading(false);
    if (result.error) { setError(result.error); return; }
    setSuccess(true);
    setTimeout(() => { window.location.href = '/login'; }, 3000);
  }

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.brand}>
          <div style={styles.logoBox}>
            <img src={logo} alt="LinchpinCRT" style={{ height: '48px', width: 'auto' }} />
          </div>
          <div>
            <div style={styles.productName}>LinchpinCRT</div>
            <div style={styles.tagline}>Reset your password</div>
          </div>
        </div>
        <div style={styles.divider} />

        {success ? (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ fontSize: '32px', marginBottom: '12px' }}>✅</div>
            <div style={{ color: '#6EE7A0', fontFamily: 'monospace', fontSize: '13px', fontWeight: '700', marginBottom: '8px' }}>
              Password updated successfully!
            </div>
            <div style={{ color: '#4B5578', fontSize: '12px' }}>Redirecting to login...</div>
          </div>
        ) : (
          <form onSubmit={handleReset} style={styles.form}>
            <div style={styles.field}>
              <label style={styles.label}>Email</label>
              <input style={styles.input} type="email" placeholder="your@email.com"
                value={email} onChange={e => setEmail(e.target.value)}
                required disabled={loading}
                onFocus={e => e.target.style.borderColor = '#2563EB'}
                onBlur={e => e.target.style.borderColor = '#2A3350'} />
            </div>

            <div style={styles.field}>
              <label style={styles.label}>Reset Code</label>
              <div style={{ display: 'flex', gap: '8px' }}>
                <input style={{ ...styles.input, flex: 1 }} type="text" placeholder="6-digit code from email"
                  value={code} onChange={e => setCode(e.target.value)}
                  required disabled={loading}
                  onFocus={e => e.target.style.borderColor = '#2563EB'}
                  onBlur={e => e.target.style.borderColor = '#2A3350'} />
                <button type="button"
                  onClick={async () => {
                    if (!email.trim()) { setError('Enter your email first.'); return; }
                    setLoading(true); setError('');
                    const result = await fetch('/auth/forgot-password', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ email })
                    }).then(r => r.json());
                    setLoading(false);
                    if (result.error) { setError(result.error); return; }
                    setCodeSent(true);
                  }}
                  disabled={loading}
                  style={{ fontFamily: 'monospace', fontSize: '10px', fontWeight: '700', padding: '0 12px', borderRadius: '8px', border: 'none', background: '#2563EB', color: '#fff', cursor: 'pointer', whiteSpace: 'nowrap', opacity: loading ? 0.5 : 1 }}>
                  {codeSent ? 'Resend' : 'Send Code'}
                </button>
              </div>
              {codeSent && <div style={{ fontFamily: 'monospace', fontSize: '10px', color: '#6EE7A0', marginTop: '4px' }}>✓ Code sent! Check your email.</div>}
            </div>

            <div style={styles.field}>
              <label style={styles.label}>New Password</label>
              <input style={styles.input} type="password" placeholder="Min 8 characters"
                value={password} onChange={e => setPassword(e.target.value)}
                required disabled={loading}
                onFocus={e => e.target.style.borderColor = '#2563EB'}
                onBlur={e => e.target.style.borderColor = '#2A3350'} />
            </div>

            <div style={styles.field}>
              <label style={styles.label}>Confirm Password</label>
              <input style={styles.input} type="password" placeholder="Repeat password"
                value={confirm} onChange={e => setConfirm(e.target.value)}
                required disabled={loading}
                onFocus={e => e.target.style.borderColor = '#2563EB'}
                onBlur={e => e.target.style.borderColor = '#2A3350'} />
            </div>

            <div style={{ background: '#0B0D15', border: '1px solid #2A3350', borderRadius: '8px', padding: '12px 14px' }}>
              {requirements.map((req, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: i < requirements.length - 1 ? '6px' : 0 }}>
                  <span style={{ fontSize: '12px', color: req.met ? '#6EE7A0' : '#4B5578' }}>{req.met ? '✓' : '○'}</span>
                  <span style={{ fontFamily: 'monospace', fontSize: '11px', color: req.met ? '#6EE7A0' : '#4B5578' }}>{req.label}</span>
                </div>
              ))}
              {confirm.length > 0 && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '6px' }}>
                  <span style={{ fontSize: '12px', color: password === confirm ? '#6EE7A0' : '#FCA5A5' }}>{password === confirm ? '✓' : '✗'}</span>
                  <span style={{ fontFamily: 'monospace', fontSize: '11px', color: password === confirm ? '#6EE7A0' : '#FCA5A5' }}>{password === confirm ? 'Passwords match' : 'Do not match'}</span>
                </div>
              )}
            </div>

            {error && <div style={styles.error}>{error}</div>}

            <button type="submit" disabled={loading || !allMet || password !== confirm || !code}
              style={{ ...styles.btn, opacity: (loading || !allMet || password !== confirm || !code) ? 0.4 : 1 }}>
              {loading ? 'Updating...' : 'Set New Password'}
            </button>

            <div style={{ textAlign: 'center' }}>
              <a href="/login" style={{ color: '#4B5578', fontSize: '12px', fontFamily: 'monospace', textDecoration: 'underline' }}>
                ← Back to login
              </a>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', background: '#0B0D15', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'IBM Plex Sans', sans-serif" },
  card: { background: '#10121E', border: '1px solid #2A3350', borderRadius: '12px', padding: '40px', width: '440px', boxShadow: '0 25px 50px rgba(0,0,0,0.6)' },
  brand: { display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' },
  logoBox: { width: '48px', height: '48px', background: '#1A3A7A', border: '2px solid #2563EB', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  logoText: { color: '#93C5FD', fontFamily: 'monospace', fontWeight: '700', fontSize: '22px' },
  productName: { color: '#E2E8F0', fontFamily: 'monospace', fontWeight: '700', fontSize: '20px', letterSpacing: '0.04em' },
  tagline: { color: '#4B5578', fontSize: '12px', fontFamily: 'monospace', letterSpacing: '0.08em', marginTop: '3px', fontWeight: '600' },
  divider: { height: '1px', background: '#2A3350', marginBottom: '28px' },
  form: { display: 'flex', flexDirection: 'column', gap: '16px' },
  field: { display: 'flex', flexDirection: 'column', gap: '6px' },
  label: { color: '#4B5578', fontSize: '11px', fontFamily: 'monospace', letterSpacing: '0.08em', textTransform: 'uppercase', fontWeight: '700' },
  input: { background: '#0B0D15', border: '1px solid #2A3350', borderRadius: '8px', padding: '11px 14px', color: '#E2E8F0', fontSize: '14px', fontFamily: 'monospace', outline: 'none', transition: 'border-color 0.15s' },
  error: { background: '#450A0A', border: '1px solid #EF4444', borderRadius: '8px', padding: '10px 14px', color: '#FCA5A5', fontSize: '12px', fontFamily: 'monospace', fontWeight: '600' },
  btn: { background: '#2563EB', border: 'none', borderRadius: '8px', padding: '12px', color: '#fff', fontFamily: 'monospace', fontWeight: '700', fontSize: '13px', letterSpacing: '0.05em', cursor: 'pointer', marginTop: '4px', transition: 'opacity 0.15s' },
};